// extracted by mini-css-extract-plugin
export default {"toolbar":"style_toolbar__-9Vbk"};